// We have to explicitly annotate the types, so that these types are not "string" but the actual string literals.
const ActionNames: {
  // Submission Page App State Actions
  PEER_SUBMISSION_APP_STATE_READY: 'PEER_SUBMISSION_APP_STATE_READY';

  PEER_SUBMISSION_APP_STATE_SAVING: 'PEER_SUBMISSION_APP_STATE_SAVING';
  PEER_SUBMISSION_APP_STATE_AUTO_SAVING: 'PEER_SUBMISSION_APP_STATE_AUTO_SAVING';
  PEER_SUBMISSION_APP_STATE_SAVE_ERROR: 'PEER_SUBMISSION_APP_STATE_SAVE_ERROR';
  PEER_SUBMISSION_APP_STATE_SAVE_SUCCESS: 'PEER_SUBMISSION_APP_STATE_SAVE_SUCCESS';
  PEER_SUBMISSION_APP_STATE_AUTO_SAVE_SUCCESS: 'PEER_SUBMISSION_APP_STATE_AUTO_SAVE_SUCCESS';

  PEER_SUBMISSION_APP_STATE_SUBMITTING: 'PEER_SUBMISSION_APP_STATE_SUBMITTING';
  PEER_SUBMISSION_APP_STATE_SUBMIT_ERROR: 'PEER_SUBMISSION_APP_STATE_SUBMIT_ERROR';
  PEER_SUBMISSION_APP_STATE_SUBMIT_SUCCESS: 'PEER_SUBMISSION_APP_STATE_SUBMIT_SUCCESS';

  // Submissio draft Actions
  PEER_SUBMISSION_DRAFT_LOADING: 'PEER_SUBMISSION_DRAFT_LOADING';
  PEER_SUBMIT_UPDATE_ALERTS: 'PEER_SUBMIT_UPDATE_ALERTS';
  PEER_SUBMIT_UPDATE_LATEST_SUBMISSION_DRAFT: 'PEER_SUBMIT_UPDATE_LATEST_SUBMISSION_DRAFT';

  PEER_SUBMIT_LOCAL_UPDATE_DRAFT_SUBMISSION: 'PEER_SUBMIT_LOCAL_UPDATE_DRAFT_SUBMISSION';

  // Load Actions
  LOADED_PEER_REVIEW_STATS: 'LOADED_PEER_REVIEW_STATS';
  LOADED_DISPLAYABLE_PHASE_SCHEDULE: 'LOADED_DISPLAYABLE_PHASE_SCHEDULE';
  LOADED_PEER_ASSIGNMENT: 'LOADED_PEER_ASSIGNMENT';
  LOADED_PEER_SUBMISSION_DRAFT: 'LOADED_PEER_SUBMISSION_DRAFT';
  LOADED_PEER_USER_PERMISSIONS: 'LOADED_PEER_USER_PERMISSIONS';
  LOADING_PEER_ASSIGNMENT: 'LOADING_PEER_ASSIGNMENT';
  LOADING_PEER_USER_PERMISSIONS: 'LOADING_PEER_USER_PERMISSIONS';
  LOADED_PEER_USER_SUBMISSION_PROGRESSES: 'LOADED_PEER_USER_SUBMISSION_PROGRESSES';

  // Alerts
  PEER_UPDATE_ALERT_SEVERITY: 'PEER_UPDATE_ALERT_SEVERITY';

  // View Submission Actions
  PEER_VIEW_SUBMISSION_LOADING: 'PEER_VIEW_SUBMISSION_LOADING';
  PEER_VIEW_SUBMISSION_LOADED: 'PEER_VIEW_SUBMISSION_LOADED';
  PEER_VIEW_SUBMISSION_LOAD_ERROR: 'PEER_VIEW_SUBMISSION_LOAD_ERROR';
  PEER_VIEW_SUBMISSION_LOAD_RESET: 'PEER_VIEW_SUBMISSION_LOAD_RESET';
  PEER_VIEW_SUBMISSION_LOCAL_LIKE_SUBMISSION: 'PEER_VIEW_SUBMISSION_LOCAL_LIKE_SUBMISSION';
  PEER_VIEW_SUBMISSION_LOCAL_UNDO_LIKE_SUBMISSION: 'PEER_VIEW_SUBMISSION_LOCAL_UNDO_LIKE_SUBMISSION';
  PEER_VIEW_SUBMISSION_FLAGGING: 'PEER_VIEW_SUBMISSION_FLAGGING';
  PEER_VIEW_SUBMISSION_FLAGGED: 'PEER_VIEW_SUBMISSION_FLAGGED';
  PEER_VIEW_SUBMISSION_FLAG_ERROR: 'PEER_VIEW_SUBMISSION_FLAG_ERROR';
  PEER_VIEW_SUBMISSION_SKIPPING: 'PEER_VIEW_SUBMISSION_SKIPPING';
  PEER_VIEW_SUBMISSION_SKIPPED: 'PEER_VIEW_SUBMISSION_SKIPPED';
  PEER_VIEW_SUBMISSION_SKIP_ERROR: 'PEER_VIEW_SUBMISSION_SKIP_ERROR';

  // Review Submission Actions
  REVIEW_SUBMISSION_INITIALIZE: 'REVIEW_SUBMISSION_INITIALIZE';
  REVIEW_SUBMISSION_LOCAL_UPDATE_REVIEW: 'REVIEW_SUBMISSION_LOCAL_UPDATE_REVIEW';
  REVIEW_SUBMISSION_SUBMITTING: 'REVIEW_SUBMISSION_SUBMITTING';
  REVIEW_SUBMISSION_SUBMIT_ERROR: 'REVIEW_SUBMISSION_SUBMIT_ERROR';
  REVIEW_SUBMISSION_SUBMITTED: 'REVIEW_SUBMISSION_SUBMITTED';

  // View Review Queue Actions
  REVIEW_QUEUE_LOADED: 'REVIEW_QUEUE_LOADED';
  REVIEW_QUEUE_ERROR: 'REVIEW_QUEUE_ERROR';
  REVIEW_QUEUE_LOADING: 'REVIEW_QUEUE_LOADING';
} = {
  // Submission Page App State Actions
  PEER_SUBMISSION_APP_STATE_READY: 'PEER_SUBMISSION_APP_STATE_READY',

  PEER_SUBMISSION_APP_STATE_SAVING: 'PEER_SUBMISSION_APP_STATE_SAVING',
  PEER_SUBMISSION_APP_STATE_AUTO_SAVING: 'PEER_SUBMISSION_APP_STATE_AUTO_SAVING',
  PEER_SUBMISSION_APP_STATE_SAVE_ERROR: 'PEER_SUBMISSION_APP_STATE_SAVE_ERROR',
  PEER_SUBMISSION_APP_STATE_SAVE_SUCCESS: 'PEER_SUBMISSION_APP_STATE_SAVE_SUCCESS',
  PEER_SUBMISSION_APP_STATE_AUTO_SAVE_SUCCESS: 'PEER_SUBMISSION_APP_STATE_AUTO_SAVE_SUCCESS',

  PEER_SUBMISSION_APP_STATE_SUBMITTING: 'PEER_SUBMISSION_APP_STATE_SUBMITTING',
  PEER_SUBMISSION_APP_STATE_SUBMIT_ERROR: 'PEER_SUBMISSION_APP_STATE_SUBMIT_ERROR',
  PEER_SUBMISSION_APP_STATE_SUBMIT_SUCCESS: 'PEER_SUBMISSION_APP_STATE_SUBMIT_SUCCESS',

  // Submission Draft Actions
  PEER_SUBMISSION_DRAFT_LOADING: 'PEER_SUBMISSION_DRAFT_LOADING',
  PEER_SUBMIT_UPDATE_ALERTS: 'PEER_SUBMIT_UPDATE_ALERTS',
  PEER_SUBMIT_UPDATE_LATEST_SUBMISSION_DRAFT: 'PEER_SUBMIT_UPDATE_LATEST_SUBMISSION_DRAFT',

  PEER_SUBMIT_LOCAL_UPDATE_DRAFT_SUBMISSION: 'PEER_SUBMIT_LOCAL_UPDATE_DRAFT_SUBMISSION',

  // Load Actions
  LOADED_PEER_REVIEW_STATS: 'LOADED_PEER_REVIEW_STATS',
  LOADED_DISPLAYABLE_PHASE_SCHEDULE: 'LOADED_DISPLAYABLE_PHASE_SCHEDULE',
  LOADED_PEER_ASSIGNMENT: 'LOADED_PEER_ASSIGNMENT',
  LOADED_PEER_SUBMISSION_DRAFT: 'LOADED_PEER_SUBMISSION_DRAFT',
  LOADED_PEER_USER_PERMISSIONS: 'LOADED_PEER_USER_PERMISSIONS',
  LOADING_PEER_ASSIGNMENT: 'LOADING_PEER_ASSIGNMENT',
  LOADING_PEER_USER_PERMISSIONS: 'LOADING_PEER_USER_PERMISSIONS',
  LOADED_PEER_USER_SUBMISSION_PROGRESSES: 'LOADED_PEER_USER_SUBMISSION_PROGRESSES',

  // Alerts
  PEER_UPDATE_ALERT_SEVERITY: 'PEER_UPDATE_ALERT_SEVERITY',

  // View Submission Actions
  PEER_VIEW_SUBMISSION_LOADING: 'PEER_VIEW_SUBMISSION_LOADING',
  PEER_VIEW_SUBMISSION_LOADED: 'PEER_VIEW_SUBMISSION_LOADED',
  PEER_VIEW_SUBMISSION_LOAD_ERROR: 'PEER_VIEW_SUBMISSION_LOAD_ERROR',
  PEER_VIEW_SUBMISSION_LOAD_RESET: 'PEER_VIEW_SUBMISSION_LOAD_RESET',
  PEER_VIEW_SUBMISSION_LOCAL_LIKE_SUBMISSION: 'PEER_VIEW_SUBMISSION_LOCAL_LIKE_SUBMISSION',
  PEER_VIEW_SUBMISSION_LOCAL_UNDO_LIKE_SUBMISSION: 'PEER_VIEW_SUBMISSION_LOCAL_UNDO_LIKE_SUBMISSION',
  PEER_VIEW_SUBMISSION_FLAGGING: 'PEER_VIEW_SUBMISSION_FLAGGING',
  PEER_VIEW_SUBMISSION_FLAGGED: 'PEER_VIEW_SUBMISSION_FLAGGED',
  PEER_VIEW_SUBMISSION_FLAG_ERROR: 'PEER_VIEW_SUBMISSION_FLAG_ERROR',
  PEER_VIEW_SUBMISSION_SKIPPING: 'PEER_VIEW_SUBMISSION_SKIPPING',
  PEER_VIEW_SUBMISSION_SKIPPED: 'PEER_VIEW_SUBMISSION_SKIPPED',
  PEER_VIEW_SUBMISSION_SKIP_ERROR: 'PEER_VIEW_SUBMISSION_SKIP_ERROR',

  // Review Submission Actions
  REVIEW_SUBMISSION_INITIALIZE: 'REVIEW_SUBMISSION_INITIALIZE',
  REVIEW_SUBMISSION_LOCAL_UPDATE_REVIEW: 'REVIEW_SUBMISSION_LOCAL_UPDATE_REVIEW',
  REVIEW_SUBMISSION_SUBMITTING: 'REVIEW_SUBMISSION_SUBMITTING',
  REVIEW_SUBMISSION_SUBMIT_ERROR: 'REVIEW_SUBMISSION_SUBMIT_ERROR',
  REVIEW_SUBMISSION_SUBMITTED: 'REVIEW_SUBMISSION_SUBMITTED',

  // View Review Queue Actions
  REVIEW_QUEUE_LOADED: 'REVIEW_QUEUE_LOADED',
  REVIEW_QUEUE_ERROR: 'REVIEW_QUEUE_ERROR',
  REVIEW_QUEUE_LOADING: 'REVIEW_QUEUE_LOADING',
};

export { ActionNames };
